import React from 'react';
import { Link } from 'react-router-dom';
import AntromLogo from '../../../assets/antrom-logo.svg?react';

export default function Logo() {
  return (
    <Link to="/" className="flex items-center justify-center gap-2">
      <AntromLogo className="h-10 w-auto" />
      <span className="font-anta text-4xl text-indigo-400">Antrom</span>
    </Link>
  );
}